export const STORE_IOS = 'https://apps.apple.com/gb/app/armwrestling-workout-tracker/id6755335262';
export const STORE_ANDROID = 'https://play.google.com/store/apps/details?id=com.armprogress.app';
